import { render, staticRenderFns } from "./TrafficTime.vue?vue&type=template&id=50d8494e&scoped=true&"
import script from "./TrafficTime.vue?vue&type=script&lang=js&"
export * from "./TrafficTime.vue?vue&type=script&lang=js&"
import style0 from "./TrafficTime.vue?vue&type=style&index=0&id=50d8494e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d8494e",
  null
  
)

export default component.exports